<template>
  <div>
    <div class="position-relative mb-3">
    <div class="grid--three-column">
      <ValidatedInput
        rules="required"
        :label="label + ' City'"
        id="delivery-city"
        text-transform="capitalize"
        :value="formFields.city"
        :errors="errorResolver('city')"
        @input="newValue => handleInputChange({ field: 'city', newValue })"
        class="mb-0"
      />
      <ValidatedInput
        rules="required"
        :label="label + ' State'"
        id="delivery-state"
        :value="formFields.state"
        :errors="errorResolver('state')"
        @input="newValue => handleInputChange({ field: 'state', newValue })"
        class="mb-0"
      />
      <ValidatedInput
        rules="required"
        :label="label + ' Zip'"
        id="delivery-zip"
        :value="formFields.zip"
        :errors="errorResolver('zip')"
        @input="newValue => handleInputChange({ field: 'zip', newValue })"
        class="mb-0"
      />
    </div>
    <LocationSuggestions
      v-if="show_suggesions"
      :city="formFields.city"
      :zip="formFields.zip"
      @select="e => handleSuggestion(e)"
    />
    </div>

    <ValidatedInput
      label="Address line 1"
      id="address-1"
      text-transform="capitalize"
      :value="formFields.address"
      :errors="errorResolver('address')"
      @input="newValue => handleInputChange({ field: 'address', newValue })"
    />
    <ValidatedInput
      label="Address line 2"
      id="address-2"
      :value="formFields.address2"
      :errors="errorResolver('address2')"
      @input="newValue => handleInputChange({ field: 'address2', newValue })"
    />
    <ValidatedSelect
      label="Location type"
      id="locationType"
      :value="String(formFields.locationTypeId)"
      :options="locationTypes"
      @input="newValue => handleInputChange({ field: 'locationTypeId', newValue })"
      :errors="errorResolver['locationTypeId']"
    />

  </div>
</template>

<script>
import ValidatedInput from '@/components/shared/ValidatedInput';
import ValidatedSelect from '@/components/shared/ValidatedMultiselect';
import locationTypesMixin from '@/mixins/locationTypes';
import LocationSuggestions from '@/components/shared/formFields/LocationSuggestions.vue';

export default {
  components: {
    ValidatedInput,
    ValidatedSelect,
    LocationSuggestions
  },
  mixins: [locationTypesMixin],
  props: {
    formFields: {
      type: Object,
      default: () => ({}),
    },
    errorResolver: {
      type: Function,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      suggestions: [],
      suggestionsCount: 10,
      loading: false,
      show_suggesions: false,
    };
  },
  methods: {
    handleInputChange({ field, newValue }) {
      const newFormFields = Object.assign({}, this.formFields);
      newFormFields[field] = newValue;
      this.$emit('input', newFormFields);

      if (field == 'city' || field == 'zip'){
        const searchTerm = ((newFormFields.zip || '') + ',' + (newFormFields.city || '')).trim()
        this.show_suggesions = searchTerm.length > 2
      }
    },
    handleSuggestion(item) {
      const newFormFields = Object.assign({}, this.formFields, item);
      this.$emit('input', newFormFields);
      this.show_suggesions = false
    },
  },
};
</script>

<style lang="scss" scoped>
.grid--three-column {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 0px;
}
</style>
